<template>
    <div class="section" v-show="showPlans">
        <h2 class="sectionTitle">Latest Well Plans</h2>
        <div class="sectionContent cardPlacement">
           <div class="logCard" v-for="(wp, index) in wellPlans" :key="index">
               <div>
                   <div v-for="obj in formatGeneral(wp)" :key="obj.field" class="dataItem">
                        <p v-if="obj.field === 'Operator'">{{obj.field}}: <router-link :to="{name: 'Operators', params: {operator: wp.operShort}}" class="link dataEmphasis">{{obj.val}}</router-link></p>
                        <p v-else-if="obj.field === 'Lease Number'">{{obj.field}}: <router-link :to="{name: 'Leases', params: {lease: wp.leaseNum}}" class="link dataEmphasis">{{obj.val}}</router-link></p>
                        <p v-else-if="obj.val">{{obj.field}}: <span class="dataEmphasis">{{obj.val}}</span></p>
                        <p v-else><span class="dataEmphasis">{{obj.field}}</span></p>
                    </div>
               </div>
               <div>
                    <div v-for="obj in formatDetails(wp)" :key="obj.field" class="dataItem">
                        <p v-if="obj.val">{{obj.field}}: <span class="dataEmphasis">{{obj.val}}</span></p>
                        <a v-else-if="obj.link" class="dataEmphasis link" :href="obj.link">{{obj.field}}</a>
                        <p v-else><span class="dataEmphasis">{{obj.field}}</span></p>
                    </div>
               </div>
           </div>
        </div>
    </div>
</template>

<script>
import { formatDateLT, readFromObj } from '../../helpers/Formatting.js';

export default {
    name: 'trending-latest-well-plans',
    data: () => ({
        showPlans: false,
        wellPlans: [],
    }),
    methods: {
        updateInfo: function(wellPlans) {
            var globv = this;
            globv.wellPlans = wellPlans;
            globv.showPlans = globv.wellPlans.length > 0;
        },
        formatGeneral: function(wp) {
            let expectedVariables = [
                {
                    varName: "planType",
                    fieldName: "Type"
                },
                {
                    varName: "operator",
                    fieldName: "Operator"
                },
                {
                    varName: "surfaceBlock",
                    fieldName: "Block"
                },
                {
                    varName: "leaseNum",
                    fieldName: "Lease Number"
                },
                {
                    varName: "submitDate",
                    fieldName: "Submit Date",
                    format: formatDateLT
                }
            ]

            return readFromObj(wp, expectedVariables);
        },
        formatDetails: function(wp) {
            let expectedVariables = [
                {
                    varName: "protraction",
                    fieldName: "Protraction"
                },
                {
                    varName: "wellPlanType",
                    fieldName: "Well Plan Type"
                },
                {
                    varName: "site.name",
                    fieldName: "Site Name",
                },
                {
                    varName: "site.type",
                    fieldName: "Site Type"
                },
                {
                    varName: "sourceUrl",
                    fieldName: "Source",
                    link: true
                }
            ]

            return readFromObj(wp, expectedVariables);
        }
    }
}
</script>